import React from 'react';

import { SalesPerformance } from '@models/SalesPerformance';
import { Kpi } from '@utils/Formatters';
import PosFact from '../pos-fact/PosFact';
import { GrowthTypes } from '../comparison-growth-selector/Types';
import { FactRevenue } from '@utils/pageConfig/Types';
import { constructCurrencyLabel } from '@utils/currencyUtils/CurrencyUtils';

export interface SalePerformanceProps {
  performance?: SalesPerformance;
  selectedGrowthType: GrowthTypes;
  kpiType: Kpi;
  factRevenue: FactRevenue;
}

const MarketPerformanceSummary: React.FC<SalePerformanceProps> = ({
  performance,
  selectedGrowthType,
  kpiType,
  factRevenue,
}) => {
  const currencyLabel = kpiType === Kpi.marketRevenue ? constructCurrencyLabel(factRevenue) : '';
  return (
    <div className="flex mt-6 w-full">
      <PosFact
        growthAvailable={true}
        value={performance?.marketPerformance?.revenue?.value}
        percentage={performance?.marketPerformance?.growth?.percentage}
        actual={performance?.marketPerformance?.growth?.value}
        type={kpiType}
        growthType={selectedGrowthType}
        growthTypeText={`Market${currencyLabel}`}
        currency={factRevenue.currencySymbol}
      />
      <PosFact
        growthAvailable={true}
        value={performance?.myPerformance?.revenue?.value}
        percentage={performance?.myPerformance?.growth?.percentage}
        actual={performance?.myPerformance?.growth?.value}
        type={kpiType}
        growthType={selectedGrowthType}
        growthTypeText={`Retailer Performance${currencyLabel}`}
        currency={factRevenue.currencySymbol}
      />
      <PosFact
        growthAvailable={true}
        value={performance?.myRevenueShare?.selectedPeriod?.sharePercentage}
        actual={performance?.myRevenueShare?.selectedPeriod?.growthPercentage}
        type={Kpi.revenueShare}
        growthType={GrowthTypes.actual}
        growthTypeText={'Retailer Share'}
      />
    </div>
  );
};

export default MarketPerformanceSummary;
